// TODO merge with FilteringService
import {EventEmitter, Injectable} from '@angular/core';
import {User} from '@app/core/model/user';
import {BehaviorSubject, combineLatest, Observable, of, ReplaySubject, Subscription} from 'rxjs';
import {Integration} from '@app/views/admin/application-settings/models/integration.model';
import {RestrictionSet} from '@app/core/model/filtering/restriction-set';
import {
    AttributeEntity,
    AttributeEntityItem,
    AttributeMetadataModel,
    copyData,
    OneAttributeEntity
} from '@app/core/model/integration-models';
import {MetadataModel} from '@app/core/model/filtering/metadata-model';
import {
    DATA_BROWSING_ENTITY_TYPES,
    ENTITY_DETAIL_ROUTES
} from '@app/views/databrowsing/model/entities-detail-routes.model';
import {IEntity, ILightEntity} from '@app/views/databrowsing/model/common.data.models';
import {FilteringChangeEvent} from '@app/core/model/filtering/filtering-change-event';
import {EntitiesMetadata} from '@app/core/model/entities-metadata';
import {IntegrationService} from '@app/core/service/integration.service';
import {OrgsService} from '@app/core/service/orgs.service';
import {select, Store} from '@ngrx/store';
import {getAuthenticatedUser, getProviderApplications, State} from '@app/app.reducers';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';
import {CustomerService} from '@app/core/service/customer.service';
import {LiteInstitutionModel} from '@app/core/model/institutional-model';
import {ApplicationProviderListModel} from '@app/views/admin/application-settings/models/application-provider-list.model';
import * as ApplicationSettingsActions from '@app/views/admin/application-settings/store/application-settings.actions';
import {RestrictionRule} from '@app/core/model/filtering/restriction-rule';
import {RestrictionFilter} from '@app/core/model/filtering/restriction-filter';
import {
    AttributeType,
    DataBrowsingFilterDefaultPredicateMap,
    DataBrowsingFilterPredicateFriendlyName,
    DataBrowsingFilterPredicateMap,
    DefaultDataBrowsingFilterPredicates,
    FilterPredicate
} from '@app/core/model/filtering/filter-predicate';
import {PredicateModel} from '@app/core/model/filtering/predicate-model';
import {distinctUntilChanged, filter, map, mergeMap, switchMap, takeWhile, tap, take} from 'rxjs/operators';
import * as Entity from '@app/views/databrowsing/model/rostering.models';
import * as EntityModel from '@app/views/databrowsing/model/rostering.models';
import * as GradebookModel from '@app/views/databrowsing/model/gradebook.models';
import * as ResourceModel from '@app/views/databrowsing/model/resource.models';
import {IntegrationState} from '@app/views/admin/application-settings/models/integration-state.model';
import {SchoolFilterType, SchoolProfileModel} from '@app/core/model/entity-profile';
import {
    DataAttribute,
    EduToneExtensionFields,
    IDataAttributeExtensionAttribute,
    OneRosterExtensionSufix,
    OneRosterExtensionTitleSufix
} from '@app/views/admin/application-settings/models/data-attribute.model';
import {EntityAttributeMetadata} from '@app/core/model/entity-attribute-metadata';
import {FiltersListService} from '@app/views/admin/application-settings/components/filters/filters-list-wrapper/filters-list.service';
import {Page} from '@app/views/databrowsing/model/page';
import {PagedData, PagedDataItem} from '@app/views/databrowsing/model/paged-data';
import {DataBrowsingService} from '@app/views/databrowsing/databrowsing.service';
import {BrowserEntityView, createBrowserEntityViewInstance, IBrowserEntityView} from '@app/views/databrowsing/browser-entity-view';
import {
    ATTRIBUTE_COUNTER_SUFFIX,
    DatabrowsingOptions,
    DownloadMediaTypes
} from '@app/views/databrowsing/model/databrowsing-options.model';
import {SchoolEntityTotals, SchoolsEntityTotals} from '@app/views/databrowsing/model/entity-totals';
import {IDataBrowser} from '@app/views/databrowsing/model/idata-browser.model';
import {IStoredRestrictionFilter, IStoredRestrictionRule} from '@app/core/model/filtering/stored-restriction-rule';
import {MixpanelService} from '@app/core/service/mixpanel.service';
import {environment} from '@env/environment';

@Injectable()
export class DataBrowser implements IDataBrowser {

    readonly KEY_CURR_DB_ORG = 'key-db-org-';
    readonly KEY_SHOW_RULES = 'key-show-rules-';
    readonly KEY_RULES = 'key-rules-';

    urlForTableContent: DownloadMediaTypes = DownloadMediaTypes.DATA;
    urlForDataTable: undefined;

    user: User;

    // currentEntity: string;
    onChangeCurrentEntity = new BehaviorSubject<string>(null);

    integration: Integration;
    _ruleSet: RestrictionSet;
    ruleSetChange: ReplaySubject<RestrictionSet> = new ReplaySubject();

    attrEntities: AttributeEntity[] = [];
    filtersPredicatesMetadata: MetadataModel[];

    _options: DatabrowsingOptions;

    entityIDm = {
        [DATA_BROWSING_ENTITY_TYPES.rostering]: [
            ['Districts', 'District', ENTITY_DETAIL_ROUTES['District'], 'District'],
            ['Schools', 'School', ENTITY_DETAIL_ROUTES['School'], 'School'],
            ['Students', 'Student', ENTITY_DETAIL_ROUTES['Student'], 'Student'],
            ['Contacts', 'Contact', ENTITY_DETAIL_ROUTES['Contact'], 'Contact'],
            ['Teachers', 'Teacher', ENTITY_DETAIL_ROUTES['Staff'], 'Staff'],
            ['Courses', 'Course', ENTITY_DETAIL_ROUTES['Course'], 'Course'],
            ['Classes', 'Class', ENTITY_DETAIL_ROUTES['Roster'], 'Roster'],
            ['Calendars', 'Calendar', ENTITY_DETAIL_ROUTES['Calendar'], 'Calendar'],
            ['Groups', 'Group', ENTITY_DETAIL_ROUTES['Group'], 'Group'],
            ['Admins', 'Admin', ENTITY_DETAIL_ROUTES['SchoolAdmin'], 'SchoolAdmin'],
        ],
        [DATA_BROWSING_ENTITY_TYPES.gradebook]: [
            ['Line Items', 'Line Item', ENTITY_DETAIL_ROUTES['LineItem'], 'LineItem'],
            ['Results', 'Result', ENTITY_DETAIL_ROUTES['Result'], 'Result'],
            ['Assessment Line Items', 'Assessment Line Item', ENTITY_DETAIL_ROUTES['AssessmentLineItem'], 'AssessmentLineItem'],
            ['Assessment Results', 'Assessment Result', ENTITY_DETAIL_ROUTES['AssessmentResult'], 'AssessmentResult'],
            ['Score Scales', 'Score Scale', ENTITY_DETAIL_ROUTES['ScoreScale'], 'ScoreScale'],
            ['Categories', 'Category', ENTITY_DETAIL_ROUTES['Category'], 'Category']
        ],
        [DATA_BROWSING_ENTITY_TYPES.resource]: [
            ['Resources', 'Resource', ENTITY_DETAIL_ROUTES['Resource'], 'Resource']
        ],
    };

    readonly defaultVisibleEntities = {
        [DATA_BROWSING_ENTITY_TYPES.rostering]: [
            'School', 'Student', 'Contact', 'Staff', 'Course', 'Roster', 'Group', 'Calendar', 'SchoolAdmin'
        ],
        [DATA_BROWSING_ENTITY_TYPES.gradebook]: [
            'LineItem', 'Result', 'AssessmentLineItem', 'AssessmentResult', 'ScoreScale', 'Category'
        ],
        [DATA_BROWSING_ENTITY_TYPES.resource]: [
            'Resource'
        ],
    };

    readonly ENTITY_LINK_LIST: Map<string, string> = new Map<string, string>([
        ['course', 'course'],
        ['category', 'category'],
        ['gradingPeriod', 'calendar'],
        ['academicSession', 'calendar'],
        ['student', 'student'],
        ['lineItem', 'lineItem'],
        ['scoreScale', 'scoreScale']
    ]);
    readonly ENTITY_ALIAS_LIST: Map<string, string> = new Map<string, string>([
        ['schoolyear', 'calendar'],
        ['class', 'roster'],
        ['parentAssessmentLineItem', 'assessmentLineItem'],
        ['gradingPeriod', 'calendar'],
        ['academicSession', 'calendar']
    ]);

    public entityViewsMap = new Map<string, BrowserEntityView<IEntity>[]>();
    public entityViews: BrowserEntityView<IEntity>[];
    public entityType: DATA_BROWSING_ENTITY_TYPES = DATA_BROWSING_ENTITY_TYPES.rostering;
    public dataTotalsMap: Map<string, number> = new Map<string, number>();

    allowedTransitionWithFilteringMap = new Map<string, any>([
        ['schools-students', {sourceParam: 'guid', targetParam: 'studentEnrollment.schoolId'}],
        ['schools-contacts', {sourceParam: 'guid', targetParam: 'schoolId'}],
        ['schools-staff', {sourceParam: 'guid', targetParam: 'primaryAssignment.schoolId', targetEntityUrl: 'staffs'}],
        ['schools-rosters', {sourceParam: 'guid', targetParam: 'schoolId'}],
        ['schools-courses', {sourceParam: 'guid', targetParam: 'schoolId'}],
        ['schools-calendars', {sourceParam: 'guid', targetParam: 'schoolId'}],
        ['schools-groups', {sourceParam: 'guid', targetParam: 'schoolId'}],
        ['schools-schoolAdmins', {sourceParam: 'guid', targetParam: 'primaryAssignment.schoolId', targetEntityUrl: 'school_admins'}],

        ['students-rosters', {sourceParam: 'guid', targetParam: 'students'}],
        ['students-contacts', {sourceParam: 'guid', targetParam: 'relationships.studentId'}],
        // ['students-staff', {sourceParam: 'guid', targetParam: 'students', targetEntityUrl: 'staffs'}], // No students field for Staff

        ['contacts-students', {sourceParam: 'guid', targetParam: 'studentContacts'}],

        // ['staffs-students', {sourceParam: 'guid', targetParam: 'staff'}], // No staff field for Students
        ['staffs-rosters', {sourceParam: 'guid', targetParam: 'primaryStaff.guid'}],

        // ['school_admins-students', {sourceParam: 'guid', targetParam: 'staff'}], // No staff field for Students
        ['school_admins-rosters', {sourceParam: 'guid', targetParam: 'primaryStaff.guid'}],

        // ['rosters-students', {sourceParam: 'guid', targetParam: 'rosters'}],
        // ['rosters-staff', {sourceParam: 'guid', targetParam: 'rosters', targetEntityUrl: 'staffs'}],

        // ['groups-contacts', {sourceParam: 'guid', targetParam: 'groups'}],
        // ['groups-students', {sourceParam: 'guid', targetParam: 'groups'}],
        // ['groups-staff', {sourceParam: 'guid', targetParam: 'groups', targetEntityUrl: 'staffs'}],
        // ['groups-schoolAdmins', {sourceParam: 'guid', targetParam: 'groups', targetEntityUrl: 'school_admins'}]
    ]);

    mostUsedInSearchAttributesMap = new Map<string, string[]>([
        ['School', ['guid', 'schoolName', 'localId', 'stateId', 'schoolNumber']],
        ['Student', ['guid', 'name.givenName', 'name.familyName', 'email.emailAddress', 'localId', 'stateId', 'studentNumber', 'credentials.username']],
        ['Contact', ['guid', 'name.givenName', 'name.familyName', 'email.emailAddress', 'localId', 'stateId', 'credentials.username']],
        ['Staff', ['guid', 'name.givenName', 'name.familyName', 'email.emailAddress', 'localId', 'stateId', 'staffNumber', 'credentials.username']],
        ['Course', ['guid', 'courseTitle', 'localId']],
        ['Roster', ['guid', 'sectionAlias', 'sectionName', 'localId', 'sectionNumber']],
        ['Calendar', ['guid', 'title', 'schoolYear', 'startDate', 'endDate', 'localId']],
        ['Group', ['guid', 'name']],
        ['SchoolAdmin', ['guid', 'name.givenName', 'name.familyName', 'email.emailAddress', 'localId', 'stateId', 'staffNumber', 'credentials.username']],
        ['LineItem', ['guid', 'title', 'localId']],
        ['Result', ['guid', 'score', 'scoreStatus', 'activityProgress', 'localId']],
        ['AssessmentLineItem', ['guid', 'title', 'localId']],
        ['AssessmentResult', ['guid', 'score', 'scoreStatus', 'localId']],
        ['ScoreScale', ['guid', 'title', 'localId']],
        ['Category', ['guid', 'title', 'localId']],
        ['Resource', ['guid', 'title', 'localId']]
    ]);

    metadataExtensionAttributes = new Map<string, IDataAttributeExtensionAttribute[]>([
        ['School', []],
        ['Student', [
            {
                propertyName: 'metadata.Is_identified_as_homeless',
                friendlyName: 'Identified as homeless',
                propertyTypeDenom: AttributeType.STRING
            }
        ]],
        ['Contact', [
            {
                propertyName: 'metadata.Is_identified_as_homeless',
                friendlyName: 'Identified as homeless',
                propertyTypeDenom: AttributeType.STRING
            }
        ]],
        ['Staff', [
            {
                propertyName: 'metadata.Is_identified_as_homeless',
                friendlyName: 'Identified as homeless',
                propertyTypeDenom: AttributeType.STRING
            }
        ]],
        ['Course', []],
        ['Roster', []],
        ['Calendar', []],
        ['Group', []],
        ['SchoolAdmin', [
            {
                propertyName: 'metadata.Is_identified_as_homeless',
                friendlyName: 'Identified as homeless',
                propertyTypeDenom: AttributeType.STRING
            }
        ]],
        ['LineItem', []],
        ['Result', []],
        ['AssessmentLineItem', []],
        ['AssessmentResult', []],
        ['ScoreScale', []],
        ['Category', []],
        ['Resource', []]
    ]);

    _filterShow = false;
    filterShowChange: BehaviorSubject<boolean> = new BehaviorSubject(this._filterShow);

    currentContextAppGuid: string = null;
    currentContextOrgGuid: string = null;
    currentContextIntegrationId: string = null;
    currentEntityType: DATA_BROWSING_ENTITY_TYPES = null;
    vendorAPIToken: string = null;
    onChangeCurrentOrgGuid: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    onChangeCurrentAppGuid: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    onChangeCurrentEntityType: BehaviorSubject<DATA_BROWSING_ENTITY_TYPES> = new BehaviorSubject<DATA_BROWSING_ENTITY_TYPES>(null);
    onChangeFilters: EventEmitter<FilteringChangeEvent> = new EventEmitter<FilteringChangeEvent>();
    onChangeInitialization: ReplaySubject<any> = new ReplaySubject<any>();
    initialized = false;
    hasInitializationError = false;
    isAccessTokenMissing = false;
    isTotalsDataLoading = false;
    isTotalsDataLoaded = false;

    // districtSchoolsChange: BehaviorSubject<SchoolProfileModel[]> = new BehaviorSubject<SchoolProfileModel[]>(null);
    districtSchoolsChange: BehaviorSubject<SchoolsEntityTotals> = new BehaviorSubject<SchoolsEntityTotals>(null);

    redirectChanges = new EventEmitter<any>();

    metadata: EntitiesMetadata;
    subscs: Subscription[] = [];

    onChangeRouting: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private dataBrowsingService: DataBrowsingService,
        private integrationService: IntegrationService,
        private orgsService: OrgsService,
        private store: Store<State>,
        private authenticatedUserService: AuthenticatedUserService,
        private mixpanelService: MixpanelService
    ) {
        if (CustomerService.checkIsAmplifyCustomer()) {
            this.entityIDm[DATA_BROWSING_ENTITY_TYPES.rostering] = this.entityIDm[DATA_BROWSING_ENTITY_TYPES.rostering]
                .filter((item: string[]) => item[0] !== 'Groups');
        }
        this.integration = new Integration();
        this.integration.integrationId = 'fakeId';

        /* this.onChangeCurrentOrgGuid.subscribe({
            next: (guid) => {
                this.setCurrentContextOrgGuid(guid);
            }
        });*/
    }

    defineSelectedOrganization(user: User, organizations: LiteInstitutionModel[], customContextOrgGuid: string = null) {
        if (organizations.length !== 0 || this.authenticatedUserService.isVendor(user)) {
            let stOrgGuid = this.restoreContextIdFromLocalStorage(user.email);
            if (stOrgGuid) {
                const stOrganization = organizations.find(o => o.institutionGuid === stOrgGuid);
                if (stOrganization) {
                    this.setCurrentContextIntegrationId(stOrganization.integrationId);
                    stOrgGuid = stOrganization.institutionGuid;
                } else {
                    this.setCurrentContextIntegrationId(organizations[0].integrationId);
                    stOrgGuid = organizations[0].institutionGuid;
                }
                // this.onChangeCurrentOrgGuid.next(stOrgGuid);
                if (this.currentContextOrgGuid !== stOrgGuid) {
                    this.onChangeCurrentOrgGuid.next(stOrgGuid);
                }
            } else if (this.currentContextOrgGuid !== organizations[0].institutionGuid) {
                this.setCurrentContextIntegrationId(organizations[0].integrationId);
                this.onChangeCurrentOrgGuid.next(organizations[0].institutionGuid);
            } else {
                this.setCurrentContextIntegrationId('');
                this.onChangeCurrentOrgGuid.next('');
            }
        } else {
            const orgGuid = (customContextOrgGuid ? customContextOrgGuid : user.orgGuid);
            this.onChangeCurrentOrgGuid.next(orgGuid);
        }
    }

    defineSelectedApplication(user: User, applications: ApplicationProviderListModel[], customContextAppGuid: string = null) {
        if (applications.length !== 0) {
            const contextId = customContextAppGuid
                ? customContextAppGuid
                : this.restoreContextIdFromLocalStorage(user.email);

            if (contextId && contextId !== user.orgGuid) {
                const selectedApp = applications.find(app => app.guid === contextId);
                if (selectedApp) {
                    this.setCurrentContextIntegrationId(selectedApp.integrationId);
                    this.onChangeCurrentAppGuid.next(contextId);
                } else {
                    this.saveContextIdToLocalStorage(this.user.email, this.user.orgGuid);
                    this.setCurrentContextAppGuid('');
                    this.onChangeCurrentAppGuid = new BehaviorSubject<string>(null);
                }
            }
        } else if (this.currentContextAppGuid) {
            this.clearCurrentContextAppGuid();
            this.setCurrentContextIntegrationId('');
        }
    }

    isCustomContextOrgGuid(): boolean {
        return this.currentContextOrgGuid && this.user && this.currentContextOrgGuid !== this.user.orgGuid;
    }

    setCurrentContextOrgGuid(orgGuid: string): void {
        if (this.currentContextOrgGuid !== orgGuid) {
            this.currentContextOrgGuid = orgGuid;
            this.clearVendorAPIToken();
        }
    }

    setCurrentContextAppGuid(appGuid: string): void {
        if (this.currentContextAppGuid !== appGuid && (!this.user || appGuid !== this.user.orgGuid)) {
            this.currentContextAppGuid = appGuid;
            this.clearVendorAPIToken();
        }
    }

    clearCurrentContextAppGuid() {
        this.saveContextIdToLocalStorage(this.user.email, this.user.orgGuid);
        this.setCurrentContextAppGuid('');
        this.changeContextHandler();
        this.onChangeCurrentAppGuid.next('');
    }

    setCurrentContextIntegrationId(integrationId: string): void {
        if (this.currentContextIntegrationId !== integrationId) {
            this.currentContextIntegrationId = integrationId;
            this.store.dispatch(new ApplicationSettingsActions.AssignIntegration({...this.integration, integrationId: integrationId}));
            if (integrationId && this.currentContextOrgGuid && this.currentContextAppGuid) {
                this.store.dispatch(new ApplicationSettingsActions.GetRosterAccessProgress(this.currentContextOrgGuid));
            }
        }
    }

    restoreContextIdFromLocalStorage(userId: string): string {
        return window.localStorage.getItem(this.KEY_CURR_DB_ORG + userId);
    }

    saveContextIdToLocalStorage(userId: string, contextId: string): void {
        if (contextId !== this.restoreContextIdFromLocalStorage(userId)) {
            window.localStorage.setItem(this.KEY_CURR_DB_ORG + userId, contextId);
        }
    }

    restoreShowFiltersFromLocalStorage(userId: string) {
        const v = window.localStorage.getItem(this.KEY_SHOW_RULES + userId);
        if (v) {
            this._filterShow = v === 'true';
        }
    }

    saveShowFiltersToLocalStorage(contextId: string) {
        window.localStorage.setItem(this.KEY_SHOW_RULES + contextId, JSON.stringify(this._filterShow));
    }

    restoreStateFromLocalStorage(key: string): RestrictionRule[] {
        try {
            const storedRules: IStoredRestrictionRule[] = JSON.parse(window.localStorage.getItem(key));

            let rules: RestrictionRule[] = storedRules
                .map((storedRule: IStoredRestrictionRule) => {
                    const restrictionRule = new RestrictionRule();
                    restrictionRule.uniqId = storedRule.uniqId;
                    restrictionRule.items = storedRule.items
                        .map((storedFilter: IStoredRestrictionFilter) => {
                            const item = new RestrictionFilter(this.filtersPredicatesMetadata, null);

                            item.entity = new OneAttributeEntity(
                                'integrationId',
                                null,
                                storedFilter.entity,
                                storedFilter.entityDisplayName,
                                storedFilter.edutoneEntity || '',
                                null
                            );
                            const attrs = this.attrEntities
                                .filter((attribute: AttributeEntity) => attribute.sourceType === storedFilter.entity)
                                .reduce(((arr, attribute: AttributeEntity) => attribute.attributes || []), [])
                                .filter((attribute: AttributeEntityItem) => attribute.propertyName === storedFilter.attr);
                            item.attribute = (attrs.length > 0 ? attrs[0] : null);
                            item.entity.attribute = item.attribute;

                            if (!item.entity.edutoneEntity) {
                                const attrEntity = this.attrEntities.find((attribute: AttributeEntity) =>
                                    attribute.sourceType === storedFilter.entity
                                );
                                item.entity.edutoneEntity = attrEntity ? attrEntity.edutoneEntity : '';
                            }

                            let type = AttributeType.STRING;
                            if (item.attribute) {
                                type = this.isGuid(item.attribute.propertyTypeDenom)
                                    ? AttributeType.GUID
                                    : <AttributeType>item.attribute.propertyTypeDenom;

                                item.attribute = <AttributeEntityItem>copyData(item.attribute);
                                item.entity.attribute = item.attribute;
                                item.attribute.extensionPropertyName = (item.attribute.isExtensionField
                                    ? storedFilter.extensionAttr
                                    : null);
                            }
                            item.predicate = item.getAvailablePredicates(type)
                                .find((p: PredicateModel) => p.name === storedFilter.predicate);

                            item.value = storedFilter.value;
                            return item;
                        });
                    return restrictionRule;
                });

            if (!rules) {
                rules = [];
            }
            return rules;
        } catch (e) {
            return [];
        }
    }

    saveStateToLocalStorage(key: string) {
        try {
            if (this._ruleSet) {
                const ruleSet: IStoredRestrictionRule[] = this._ruleSet.rules.map((restrictionRule: RestrictionRule) => {
                    const ruleSet: IStoredRestrictionRule = {
                        uniqId: restrictionRule.uniqId,
                        items: []
                    };

                    ruleSet.items = restrictionRule.items.map((restrictionFilter: RestrictionFilter) => <IStoredRestrictionFilter>{
                        entity: restrictionFilter.entity ? restrictionFilter.entity.sourceType : null,
                        entityDisplayName: restrictionFilter.entity ? restrictionFilter.entity.displayType : null,
                        attr: restrictionFilter.attribute ? restrictionFilter.attribute.propertyName : null,
                        extensionAttr: restrictionFilter?.attribute?.extensionPropertyName ? restrictionFilter.attribute.extensionPropertyName : null,
                        predicate: restrictionFilter.predicate ? restrictionFilter.predicate.name : null,
                        value: restrictionFilter.predicate && restrictionFilter.predicate.isRequireArguments ? restrictionFilter.value : null
                    });
                    return ruleSet;
                });
                window.localStorage.setItem(key, JSON.stringify(ruleSet));
            }
        } catch (e) {
            console.log(e);
        }
    }

    set filterShow(val: boolean) {
        this._filterShow = val;
        this.filterShowChange.next(this._filterShow);
    }

    get filterShow(): boolean {
        return this._filterShow;
    }

    set options(val: DatabrowsingOptions) {
        this._options = val;
    }

    get options() {
        return this._options;
    }

    getFiltersStorageKey() {
        return this.KEY_RULES + this.user.email + '-' + this.currentContextOrgGuid + '-' + this.currentContextAppGuid;
    }

    getAllCompletedFilters(): Array<RestrictionFilter> {
        return this._ruleSet.rules
            .reduce((arr: Array<RestrictionFilter>, rule: RestrictionRule) => {
                arr = arr.concat(rule.items.filter((filterItem: RestrictionFilter) => filterItem.isCompleted()));
                return arr;
            }, <Array<RestrictionFilter>>[]);
    }

    initialize(options: DatabrowsingOptions, ruleSet?: any) {
        this.initialized = false;
        this.entityViews = [];
        this.hasInitializationError = false;
        if (this.initialized) {
            this.initChangeEvents();
            return;
        }
        this._options = options;

        if (ruleSet) {
            this._ruleSet = ruleSet;
        } else {
            this._ruleSet = new RestrictionSet([]);
        }

        this.subscs.push(combineLatest([
            this.dataBrowsingService.getMetadata(this._options.urlForDataTable),
            this.dataBrowsingService.getDefaultSchemaAttributes(),
            this.integrationService.getPredicatesMetadata(DataBrowsingFilterDefaultPredicateMap)
                .pipe(
                    map((predicatesMetadata: MetadataModel[]) => {
                        if (!predicatesMetadata) {
                            predicatesMetadata = [];
                        }
                        return predicatesMetadata.map((predicateMetadata: MetadataModel) => {
                            predicateMetadata.predicates = predicateMetadata.predicates.filter((p: PredicateModel) =>
                                DataBrowsingFilterPredicateMap.has(p.name)
                            );

                            // Add default predicates
                            const defaultPredicates = [...DefaultDataBrowsingFilterPredicates];

                            const equalPredicate = predicateMetadata.predicates.find((predicate: PredicateModel) =>
                                predicate.name === FilterPredicate.EQUAL || predicate.name === FilterPredicate.ARRAY_ANY_EQUAL
                            );
                            if (equalPredicate) {
                                defaultPredicates.push(new PredicateModel(
                                    FilterPredicate.CONTAINS,
                                    equalPredicate.isSupportMultipleArgument,
                                    equalPredicate.isRequireArguments
                                ));
                                // Remove Equal
                                predicateMetadata.predicates = predicateMetadata.predicates.filter((predicate: PredicateModel) =>
                                    predicate.name !== FilterPredicate.EQUAL && predicate.name !== FilterPredicate.NOT_EQUAL
                                        && predicate.name !== FilterPredicate.ARRAY_ANY_EQUAL
                                );
                            }

                            const containsPredicate = predicateMetadata.predicates.find((predicate: PredicateModel) =>
                                (predicate.name === FilterPredicate.CONTAINS) || (predicate.name === FilterPredicate.ARRAY_ANY_CONTAINS)
                            );
                            if (equalPredicate || containsPredicate) {
                                defaultPredicates.push(new PredicateModel(
                                    FilterPredicate.DOES_NOT_CONTAIN,
                                    (equalPredicate || containsPredicate).isSupportMultipleArgument,
                                    (equalPredicate || containsPredicate).isRequireArguments
                                ));
                            }

                            predicateMetadata.predicates = [
                                ...predicateMetadata.predicates,
                                ...defaultPredicates.filter((defaultPredicate: PredicateModel) =>
                                    !predicateMetadata.predicates.find((predicate: PredicateModel) => predicate.name === defaultPredicate.name
                                    ))
                            ];

                            predicateMetadata.predicates = predicateMetadata.predicates.map((predicate: PredicateModel) =>
                                (<PredicateModel>{
                                    ...predicate,
                                    title: DataBrowsingFilterPredicateFriendlyName[predicate.name] || predicate.name
                                })
                            ).sort((a: PredicateModel, b: PredicateModel) => a.title.toLocaleLowerCase().localeCompare(b.title.toLocaleLowerCase()));

                            return predicateMetadata;
                        });
                    })
                )
        ]).pipe(
            map(([entitiesMetadata, attrMetadata, predicatesMetadata]:
                         [EntitiesMetadata, AttributeMetadataModel[], MetadataModel[]]
            ) => {
                let visibleEntities = this.defaultVisibleEntities[this.currentEntityType];
                if (this._options.visibleEntities) {
                    visibleEntities = this._options.visibleEntities;
                }

                Object.keys(this.entityIDm).forEach((entityType: string) => {
                    const entityViews = this.entityIDm[entityType]
                        .map(p => {
                            const ev = createBrowserEntityViewInstance(Entity[p[3] + 'Model'], this, p[0], p[1], p[2], p[3]);
                            // const ev = new BrowserEntityView<SchoolModel>(this, p[0], p[1], p[2], p[3]);
                            ev.options = options;
                            return ev;
                        });
                    this.entityViewsMap.set(entityType, entityViews);
                });
                this.entityViews = this.entityViewsMap.get(this.currentEntityType)
                    ?.filter((ev: IBrowserEntityView) => visibleEntities.indexOf(ev.eduToneEntity) > -1);

                this.processMetadata(entitiesMetadata, attrMetadata);
                this.assignDataTotalsToEntityViews();
                this.filtersPredicatesMetadata = predicatesMetadata;
            })
        )
            .subscribe(() => {

                this.initialized = true;
                this.initChangeEvents();

            }, error => {
                this.hasInitializationError = true;
                console.log(error);
            })
        );
    }

    initChangeEvents() {
        this.subscs.push(this.onChangeCurrentOrgGuid
            .pipe(distinctUntilChanged())
            .subscribe({
                next: (currOrg) => {
                    if (!currOrg) {
                        return;
                    }

                    if (this.currentContextOrgGuid !== currOrg) {
                        this.setCurrentContextOrgGuid(currOrg);
                        this.changeContextHandler();
                        this.saveContextIdToLocalStorage(this.user.email, currOrg);

                        if (this.authenticatedUserService.isVendor() && currOrg) {
                            this.store.dispatch(new ApplicationSettingsActions.GetRosterAccessProgress(currOrg));
                        }
                    } else if (!this.isTotalsDataLoaded && !this.isTotalsDataLoading) {
                        this.changeContextHandler();
                    } else if (!this.districtSchoolsChange.getValue()) {
                        this.getSchoolsData();
                    }
                }
            }));

        this.subscs.push(this.onChangeCurrentAppGuid
            .pipe(distinctUntilChanged())
            .subscribe((currentApp: string) => {
                if (!currentApp) {
                    return;
                }

                if (this.currentContextAppGuid !== currentApp) {
                    this.setCurrentContextAppGuid(currentApp);
                    if (this.authenticatedUserService.isProvider()) {
                        this.saveContextIdToLocalStorage(this.user.email, currentApp);
                    }
                    this.changeContextHandler();
                } else if (this.isTotalsDataLoaded && !this.isTotalsDataLoading) {
                    this.changeContextHandler();
                }

                if (!this.authenticatedUserService.isVendor()) {
                    this.store.dispatch(new ApplicationSettingsActions.GetRosterAccessProgress(this.currentContextOrgGuid));
                }
            })
        );

        // set listeners fo storing filters into localStorage
        setTimeout(() => {
            if (this.currentContextOrgGuid || this.currentContextAppGuid) {
                this.filterShowChange.subscribe(() => {
                    this.saveShowFiltersToLocalStorage(this.user.email);
                });

                this.subscs.push(this.onChangeFilters
                    .subscribe({
                        next: (event: FilteringChangeEvent) => {
                            this.saveStateToLocalStorage(this.getFiltersStorageKey());
                        }
                    }));
            }
        }, 500);

        this.onChangeInitialization.next({});

        this.subscs.push(
            this.store.pipe(select(getAuthenticatedUser)).subscribe((user: User) => {
                if (!user) {
                    this.clearData();
                }
            })
        );
    }

    clear() {
        this.subscs.forEach(s => s.unsubscribe());
    }

    clearData() {
        this.initialized = false;
        this.entityViews = [];
        this.setCurrentContextOrgGuid(null);
        this.setCurrentContextAppGuid(null);
        this.setCurrentContextIntegrationId(null);
        this.onChangeCurrentOrgGuid.next('');
        this.onChangeCurrentAppGuid.next('');
        this.onChangeCurrentEntity.next('');
        this.onChangeCurrentEntityType.next(null);
    }

    clearVendorAPIToken() {
        this.isAccessTokenMissing = !!this.vendorAPIToken;
        this.vendorAPIToken = null;
        this.isTotalsDataLoaded = false;
    }

    private initRuleSet() {
        if (!this._ruleSet) {
            this._ruleSet = new RestrictionSet([]);
        }

        // Restore filters from localStorage
        this.restoreShowFiltersFromLocalStorage(this.user.email);
        this._ruleSet.rules = this.restoreStateFromLocalStorage(this.getFiltersStorageKey());

        if (!this._ruleSet.rules || this._ruleSet.rules.length === 0) {
            this._ruleSet.addEmptyRule();
        }


        // event of filter initialization
        this.ruleSetChange.next(this._ruleSet);

        // fill filters for each entity view
        /* let filters = this._ruleSet.rules
            .reduce((filters, r) => filters.concat(r.items), []);

        this.entityViews.forEach(ev => {
            ev.page.filters = filters
                .filter(f => f.entity && f.entity.sourceType === ev.entity)
                .reduce((filters, f) => {
                    filters[f.attribute.propertyName] = f.value;
                    return filters;
                }, {});
        });*/
    }

    public getDataTotals(reload = false) {
        let getDataTotals$: Observable<Map<string, number>>;
        if (this.authenticatedUserService.isVendor(this.user) && this.currentContextAppGuid || this.currentContextAppGuid && this.currentContextOrgGuid) {
            if (!this.authenticatedUserService.isVendor(this.user) && this.currentContextAppGuid && this.currentContextOrgGuid) {
                getDataTotals$ = this.store.pipe(
                    select(getProviderApplications),
                    filter((applications: ApplicationProviderListModel[]) => !!applications),
                    map((applications: ApplicationProviderListModel[]) =>
                        applications.filter((application: ApplicationProviderListModel) => this.currentContextAppGuid === application.guid)
                    ),
                    filter((applications: ApplicationProviderListModel[]) => !!applications),
                    map((applications: ApplicationProviderListModel[]) =>
                        applications[0]
                    ),
                    switchMap((application: ApplicationProviderListModel) => {
                        const isMyApp = this.user && (application?.ownerId === this.user?.orgGuid);
                        if (isMyApp) {
                            this.isAccessTokenMissing = false;
                            const showStage = (application.state === IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT);
                            return this.dataBrowsingService.getProviderDataTotals(this.currentContextOrgGuid, showStage, application.guid);
                        } else {
                            return this.dataBrowsingService.getVendorDataTotals(this.currentContextOrgGuid, this.currentContextAppGuid);
                        }
                    })
                );
            } else {
                getDataTotals$ = this.dataBrowsingService.getVendorDataTotals(this.currentContextOrgGuid, this.currentContextAppGuid);
            }
        } else {
            this.isAccessTokenMissing = false;
            getDataTotals$ = this.dataBrowsingService.getProviderDataTotals(this.currentContextOrgGuid);
        }

        if (!reload) {
            this.isTotalsDataLoading = true;
            this.isTotalsDataLoaded = false;
        }
        this.subscs.push(
            getDataTotals$
                .pipe(take(1))
                .subscribe((dataTotalsMap: Map<string, number>) => {
                    this.dataTotalsMap = dataTotalsMap;
                    this.assignDataTotalsToEntityViews(reload);

                    if (!reload) {
                        this.isTotalsDataLoading = false;
                        this.isTotalsDataLoaded = true;
                    }
                })
        );
    }

    private assignDataTotalsToEntityViews(reload: boolean = false) {
        this.entityViews.forEach((entityView: BrowserEntityView<IEntity>) => {
            const total = this.dataTotalsMap.get(entityView.eduToneEntity) || 0;
            entityView.absTotal = (reload && entityView.absTotal && (entityView.absTotal > total)) ? entityView.absTotal : total;
        });
    }

    private getSchoolsData() {
        this.districtSchoolsChange.next(null);

        if (this.authenticatedUserService.isVendor() && this.currentContextAppGuid ||
            this.currentContextAppGuid && this.currentContextOrgGuid
        ) {
            this.subscs.push(
                this.orgsService.getSchoolsOfDistrict(this.currentContextOrgGuid, SchoolFilterType.ALL, this.currentContextAppGuid, null, 10000)
                    // .subscribe((schools: SchoolProfileModel[]) =>
                    //     this.districtSchoolsChange.next(schools)
                    // )
                    .pipe(map((schools: SchoolProfileModel[]) =>
                        schools.reduce((result: SchoolsEntityTotals, school: SchoolProfileModel) => {
                            result[school.schoolGuid] = new SchoolEntityTotals(
                                school.studentsShared - school.studentsSkipped,
                                school.contactsShared - school.contactsSkipped,
                                school.staffShared - school.staffSkipped,
                                school.coursesShared - school.coursesSkipped,
                                school.sectionsShared - school.sectionsSkipped,
                                school.calendarsShared - school.calendarsSkipped,
                                school.groupsShared - school.groupsSkipped,
                                school.schoolAdminsShared - school.schoolAdminsSkipped,
                                0,
                                0,
                                school.schoolGuid,
                                school.schoolName
                            );
                            return result;
                        }, new SchoolsEntityTotals())
                    ))
                    .subscribe((schoolsTotals: SchoolsEntityTotals) =>
                        this.districtSchoolsChange.next(schoolsTotals)
                    )
            );
        } else {
            // this.subscs.push(
            //     this.store.pipe(select(getProviderApplications))
            //         .pipe(
            //             filter((applications: ApplicationProviderListModel[]) => !!applications),
            //             map((applications: ApplicationProviderListModel[]) =>
            //                 applications.filter((app: ApplicationProviderListModel) =>
            //                     app.state === IntegrationState.ORIGINAL || app.state === IntegrationState.SYNCED)
            //             ),
            //             mergeMap((applications: ApplicationProviderListModel[]) => {
            //                 if (applications.length > 0) {
            //                     return this.orgsService.getSchoolsOfDistrict(
            //                         this.currentContextOrgGuid, SchoolFilterType.ACTIVE, applications[0].guid, null, 10000);
            //                 } else {
            //                     return of([]);
            //                 }
            //             })
            //
            //         ).subscribe((schools: SchoolProfileModel[]) =>
            //             this.districtSchoolsChange.next(schools)
            //         )
            // );
            this.subscs.push(
                this.dataBrowsingService.getProviderSchoolsData(this.currentContextOrgGuid)
                    .pipe(takeWhile(() => !!this.user))
                    .subscribe((schoolsTotals: SchoolsEntityTotals) => {
                        const newSchoolsTotals = this.transformSchoolsTotals(schoolsTotals);
                        return this.districtSchoolsChange.next(newSchoolsTotals);
                    })
            );
        }
    }

    private changeContextHandler() {
        this.initRuleSet();

        this.getDataTotals();

        this.getSchoolsData();
    }

    private transformSchoolsTotals(schoolsObj: SchoolsEntityTotals): SchoolsEntityTotals {
        const newSchoolsTotals: SchoolsEntityTotals = {};
        for (const key in schoolsObj) {
            if (schoolsObj.hasOwnProperty(key)
                && schoolsObj[key]) {

                const dividerIndex = key.indexOf('###');
                const schoolId = key.substring(0, dividerIndex);
                const schoolName = key.substring(dividerIndex + 3);
                newSchoolsTotals[schoolId] = Object.assign({}, schoolsObj[key], {SCHOOL_GUID: schoolId, SCHOOL_NAME: schoolName});
            }
        }
        return newSchoolsTotals;
    }

    getDownloadDataUrl() {
        const entityName = this.onChangeCurrentEntity.getValue();
        const view: BrowserEntityView<IEntity> = this.entityViews.filter(ev => ev.entity === entityName)[0];
        return this.dataBrowsingService.getDownloadDataUrl(view.page,
            this.currentContextOrgGuid,
            this._options.urlForTableContent);
    }

    processMetadata(metadata: EntitiesMetadata, attrMetadata: AttributeMetadataModel[]) {

        this.metadata = metadata;
        if (metadata) {
            this.entityViewsMap.forEach((entityViews: BrowserEntityView<IEntity>[], entityType: string) =>
                entityViews.forEach((ev: BrowserEntityView<IEntity>) => {
                    ev.page.applicationId = this.currentContextAppGuid;
                    ev.page.orgGuid = this.currentContextOrgGuid;
                    const entityName = ev.entity;
                    if (metadata[entityName]) {
                        const mostUsedAttributes = this.mostUsedInSearchAttributesMap.has(ev.eduToneEntity)
                            ? this.mostUsedInSearchAttributesMap.get(ev.eduToneEntity)
                            : [];

                        // Get attributes from attrMetadata
                        ev.attributes = attrMetadata
                            .filter((attributeMetadataModel: AttributeMetadataModel) =>
                                attributeMetadataModel.typeModel.denom === ev.eduToneEntity
                            ).map((attributeMetadataModel: AttributeMetadataModel) =>
                                attributeMetadataModel.propertyModel
                            ).reduce((previous: DataAttribute[], propertyModelList: DataAttribute[]) => propertyModelList, [])
                            // .sort((a, b) => (a.position - b.position))
                            .map((attr: DataAttribute) => ({
                                ...attr,
                                isMostUsedInSearch: mostUsedAttributes.indexOf(attr.propertyName) > -1
                            }));

                        EduToneExtensionFields.forEach((extAttrName: string) => {
                            const extensionAttr = ev.attributes
                                .find((attr: DataAttribute) => extAttrName === attr.propertyName);
                            if (extensionAttr) {
                                ev.attributes.push(
                                    new DataAttribute(
                                        extensionAttr.propertyName + OneRosterExtensionSufix,
                                        extensionAttr.friendlyName + OneRosterExtensionTitleSufix,
                                        extensionAttr.domain,
                                        extensionAttr.entityTypeDenom,
                                        'String',
                                        extensionAttr.ownerRef,
                                        extensionAttr.order,
                                        false,
                                        true,
                                        false,
                                        true
                                    ));
                            }
                        });

                        const metadataExtensionAttributes = this.metadataExtensionAttributes.get(ev.eduToneEntity);
                        if (metadataExtensionAttributes?.length > 0) {
                            metadataExtensionAttributes.forEach((metadataExtensionAttribute: IDataAttributeExtensionAttribute) =>
                                ev.attributes.push(
                                    new DataAttribute(
                                        metadataExtensionAttribute.propertyName,
                                        metadataExtensionAttribute.friendlyName,
                                        'EduTone',
                                        ev.eduToneEntity,
                                        metadataExtensionAttribute.propertyTypeDenom,
                                        0,
                                        1000,
                                        false,
                                        true,
                                        false,
                                        false
                                    ))
                            );
                        }

                        const entityLightModel = this.createLightModel(ev.eduToneEntity, entityType);

                        ev.idColumns = [];
                        metadata[entityName] = metadata[entityName]
                            .map((attributeMetadata: EntityAttributeMetadata) => {
                                const attribute = ev.attributes
                                    .find((attr: DataAttribute) => attributeMetadata.paramName === attr.propertyName);
                                let friendlyName = attribute ? attribute.friendlyName : attributeMetadata.paramName;
                                friendlyName = (friendlyName === 'Staffs' ? 'Teachers' : friendlyName);
                                attributeMetadata = <EntityAttributeMetadata>{
                                    ...attributeMetadata,
                                    friendlyName: friendlyName,
                                    type: attribute ? attribute.propertyTypeDenom : null,
                                    hasHTML: attribute ? this.cellHasHTML(attribute.propertyTypeDenom) : false,
                                    isNumber: attribute ? this.isNumber(attribute.propertyTypeDenom) : false,
                                    isGuid: attribute ? this.isGuid(attribute.propertyTypeDenom) : false,
                                    isAllowedUrl: attribute
                                        ? this.isAllowedUrl(attribute.propertyTypeDenom, ev.entity, attributeMetadata.paramName)
                                        : false
                                };

                                if (attributeMetadata.isGuid) {
                                    let paramPrefix = null;
                                    if (attributeMetadata.paramName.substr(-4) === 'Guid') {
                                        paramPrefix = attributeMetadata.paramName.substring(0, attributeMetadata.paramName.length - 4);
                                    } else if (attributeMetadata.paramName.substr(-2) === 'Id') {
                                        paramPrefix = attributeMetadata.paramName.substring(0, attributeMetadata.paramName.length - 2);
                                    } else if ((attributeMetadata.paramName === 'course') || this.ENTITY_LINK_LIST.has(attributeMetadata.paramName)) {
                                        paramPrefix = attributeMetadata.paramName;
                                    }

                                    if (paramPrefix && entityLightModel.hasOwnProperty(paramPrefix + 'Name')) {
                                        ev.idColumns.push({...attributeMetadata});
                                        attributeMetadata.paramName = paramPrefix + 'Name';
                                        let linkType = paramPrefix.substr(paramPrefix.indexOf('.') + 1).toLowerCase();
                                        // const linkType = attributeMetadata.type.substring(0, attributeMetadata.type.length - 4).toLowerCase();
                                        if (this.ENTITY_ALIAS_LIST.has(linkType)) {
                                            linkType = this.ENTITY_ALIAS_LIST.get(linkType);
                                        } else if (this.ENTITY_ALIAS_LIST.has(paramPrefix)) {
                                            linkType = this.ENTITY_ALIAS_LIST.get(paramPrefix);
                                        }
                                        attributeMetadata.type = linkType + 'Link';
                                        attributeMetadata.isGuid = false;

                                        let friendlyNamePrefix = null;
                                        const friendlyNameUpperCase = attributeMetadata.friendlyName.toUpperCase();
                                        if (friendlyNameUpperCase.substr(-' GUID'.length) === ' GUID') {
                                            friendlyNamePrefix = attributeMetadata.friendlyName
                                                .substring(0, attributeMetadata.friendlyName.length - ' GUID'.length);
                                        } else if (friendlyNameUpperCase.substr(-` ${environment.customer.guidTitle}`.length) === ` ${environment.customer.guidTitle}`) {
                                            friendlyNamePrefix = attributeMetadata.friendlyName
                                                .substring(0, attributeMetadata.friendlyName.length - ` ${environment.customer.guidTitle}`.length);
                                        } else if (friendlyNameUpperCase.substr(-' GG4L ID'.length) === ' GG4L ID') {
                                            friendlyNamePrefix = attributeMetadata.friendlyName
                                                .substring(0, attributeMetadata.friendlyName.length - ' GG4L ID'.length);
                                        } else if (friendlyNameUpperCase.substr(-' ID'.length) === ' ID') {
                                            friendlyNamePrefix = attributeMetadata.friendlyName
                                                .substring(0, attributeMetadata.friendlyName.length - ' ID'.length);
                                        } else if (attributeMetadata.friendlyName === 'Course') {
                                            friendlyNamePrefix = attributeMetadata.friendlyName;
                                        }

                                        if (friendlyNamePrefix) {
                                            attributeMetadata.friendlyName = friendlyNamePrefix;
                                            // attributeMetadata.friendlyName = friendlyNamePrefix + ' Name';
                                        }
                                    }
                                }

                                return attributeMetadata;
                            })
                            .sort((a: EntityAttributeMetadata, b: EntityAttributeMetadata) => (a.position - b.position));
                        ev.allColumns = metadata[entityName];

                        ev.page.columns = ev.allColumns.filter((col: EntityAttributeMetadata) =>
                            col.visible
                        );

                        /* ev.page.filters = ev.page.columns.reduce(function (filters, col) {
                            filters[col.paramName] = '';
                            return filters;
                        }, {});*/

                        if (ev.eduToneEntity !== 'School') {
                            metadata[entityName].forEach((attributeMetadata: EntityAttributeMetadata) => {
                                if ((attributeMetadata.friendlyName === 'Primary School')
                                    || (attributeMetadata.friendlyName === 'School')) {
                                    ev.attributes.push(new DataAttribute(
                                        attributeMetadata.paramName,
                                        attributeMetadata.friendlyName === 'Primary School' ? 'Primary School Name' : 'School Name',
                                        'EduTone',
                                        ev.eduToneEntity,
                                        'String', // attributeMetadata.type,
                                        0,
                                        attributeMetadata.position,
                                        false,
                                        true,
                                        false,
                                        false
                                    ));
                                }
                            });

                            const schoolIdAttr: DataAttribute = ev.attributes.find((attr: DataAttribute) =>
                                FiltersListService.checkIsSchoolIdSelected(attr.propertyName));
                            const schoolNameAttrExists: boolean = ev.attributes.some((attr: DataAttribute) =>
                                (attr.friendlyName === 'Primary School Name') || (attr.friendlyName === 'School Name'));
                            if (schoolIdAttr && !schoolNameAttrExists) {
                                ev.attributes.push(new DataAttribute(
                                    'schoolName',
                                    schoolIdAttr.friendlyName === 'Primary School' ? 'Primary School Name' : 'School Name',
                                    'EduTone',
                                    ev.eduToneEntity,
                                    'String', // attributeMetadata.type,
                                    0,
                                    schoolIdAttr.order,
                                    false,
                                    true,
                                    false,
                                    false
                                ));
                            }
                        }

                        ev.attributes.sort(DataAttribute.compareByPropertyName);

                        ev.page.sort = '';
                        ev.page.sorts = [];
                    } else {
                        ev.allColumns = [];
                        ev.page.columns = [];
                        // ev.page.filters = {};
                        ev.page.sort = '';
                    }
                })
            );

            const entityIds = Object.keys(metadata);
            // shaping attributes for filters
            this.attrEntities = entityIds
                .filter((entityId: string) => entityId !== 'districts')
                .map((entityId: string) => {
                    const entity = new AttributeEntity();
                    entity.sourceType = entityId;

                    let ev = null;
                    let evType = <string>DATA_BROWSING_ENTITY_TYPES.rostering;
                    this.entityViewsMap.forEach((entityViews: BrowserEntityView<IEntity>[], entityType: string) => {
                        if (!ev) {
                            ev = entityViews.find(f => f.entity === entityId);
                            evType = entityType;
                        }
                    });
                    if (ev) {
                        entity.displayType = ev.title;
                        entity.attributes = <AttributeEntityItem[]>ev.attributes;
                    } else {
                        entity.displayType = entityId.charAt(0).toUpperCase() + entityId.substr(1);
                    }

                    const entityIDIndex = this.entityIDm[<DATA_BROWSING_ENTITY_TYPES>evType].findIndex(item => item[2] === entity.sourceType);
                    if (entityIDIndex > -1) {
                        entity.position = entityIDIndex;
                        entity.edutoneEntity = this.entityIDm[<DATA_BROWSING_ENTITY_TYPES>evType][entityIDIndex][3];
                    }

                    return entity;
                })
                // .filter(attrEntity => attrEntity.sourceType !== 'districts')
                // .sort((a, b) => a.displayType > b.displayType ? 1 : a.displayType < b.displayType ? -1 : 0);
                .sort((a, b) => a.position > b.position ? 1 : a.position < b.position ? -1 : 0);
        }
    }

    public createLightModel(eduToneEntity: string, entityType: string = this.currentEntityType, row?: PagedDataItem<IEntity>): ILightEntity {
        if (entityType === DATA_BROWSING_ENTITY_TYPES.rostering) {
            return new EntityModel[eduToneEntity + 'LightModel'](row);
        } else if (entityType === DATA_BROWSING_ENTITY_TYPES.gradebook) {
            return new GradebookModel[eduToneEntity + 'LightModel'](row);
        } else if (entityType === DATA_BROWSING_ENTITY_TYPES.resource) {
            return new ResourceModel[eduToneEntity + 'LightModel'](row);
        } else {
            return null;
        }
    }

    cellHasHTML(type: string): boolean {
        return type && ((type.substr(-4) === 'Guid') || (type.substr(-6) === 'Guid[]') || (type === 'Count'));
    }

    isNumber(type: string) {
        return (type === 'Count');
    }

    isGuid(type: string) {
        return type && (type.substr(-4) === 'Guid');
    }

    isUrlTypes(type: string): boolean {
        return type && (type === 'Count' || type.substr(-4) === 'Guid');
    }

    isAllowedUrl(type: string, entity: string, paramName: string): boolean {
        return this.isUrlTypes(type) && ((type !== 'Count') || this.isAllowedTransitionWithFilteringMap(entity, paramName));
    }

    isAllowedTransitionWithFilteringMap(sourceEntity: string, paramName: string): boolean {
        const targetEntity = paramName.replace(ATTRIBUTE_COUNTER_SUFFIX, '');
        const param = this.allowedTransitionWithFilteringMap.get(sourceEntity + '-' + targetEntity);
        return !!param;
    }

    getData<EntityModelT>(page: Page, useVendorData: boolean = false): Observable<PagedData<EntityModelT>> {
        let result$: Observable<PagedData<EntityModelT>>;

        if ((this.authenticatedUserService.isVendor() || this.authenticatedUserService.isSysAdmin())
            || useVendorData
            || (this.currentContextOrgGuid && this.currentContextAppGuid && !page.showStage)
        ) {
            if (this.vendorAPIToken) {
                result$ = this.dataBrowsingService.getVendorData<EntityModelT>(page, this.vendorAPIToken);
            } else {
                result$ = this.getVendorAPIToken().pipe(
                    filter((newAccessToken: string) => !!newAccessToken),
                    mergeMap((newAccessToken: string) =>
                        this.dataBrowsingService.getVendorData<EntityModelT>(page, newAccessToken)
                    )
                );
            }
        } else {
            result$ = this.dataBrowsingService.getProviderData<EntityModelT>(page);
        }

        return result$.pipe(tap(() =>
            this.trackFilterDataBrowsing(page)
        ));
    }

    getSingleAppliedEntity(): string {
        const entities = this._ruleSet.getAppliedEntities()
            .filter((entity: string) =>
                this.entityIDm[this.currentEntityType].some((item: string[]) => item[2] === entity)
            );
        const isSingleEntityApplied = (entities.length > 0) && entities.every((entity: string) => entity === entities[0]);
        return isSingleEntityApplied ? entities[0] : null;
    }

    getVendorAPIToken(): Observable<string> {
        return this.vendorAPIToken
            ? of(this.vendorAPIToken)
            : this.orgsService.getInstitutionAccessToken(this.currentContextOrgGuid, this.currentContextAppGuid)
                .pipe(
                    tap((accessToken: string) => {
                        this.vendorAPIToken = accessToken;
                        this.isAccessTokenMissing = !accessToken;
                    })
                );
    }

    getEntityIDm(entity: string): any {
        return Object.keys(this.entityIDm)
            .map((entityType: string) => this.entityIDm[entityType].filter(ev => ev[2] === entity))
            .filter(evList => evList.length > 0)[0][0];
    }

    changeCurrentEntityType(entityType: DATA_BROWSING_ENTITY_TYPES) {
        this.currentEntityType = entityType;
        let visibleEntities = this.defaultVisibleEntities[this.currentEntityType];
        if (this._options.visibleEntities) {
            visibleEntities = this._options.visibleEntities;
        }
        this.entityViews = this.entityViewsMap.get(this.currentEntityType)
            ?.filter((ev: IBrowserEntityView) => visibleEntities.indexOf(ev.eduToneEntity) > -1);
    }

    trackFilterDataBrowsing(page: Page): void {
        const entityView = this.entityIDm[DATA_BROWSING_ENTITY_TYPES.rostering]
            .find(ev => ev[2] === page.entity);

        let filters;
        if (this._ruleSet) {
            filters = this.getAllCompletedFilters()
                .filter((filterItem: RestrictionFilter) =>
                    filterItem.entity.sourceType === page.entity
                ).map((filterItem: RestrictionFilter) => ({
                    attribute: filterItem.attribute.friendlyName,
                    predicate: filterItem.predicate.title,
                    query: filterItem.value
                }));
        } else {
            filters = page.filter;
        }

        const mixpanelProperties = {
            districtGuid: this.currentContextOrgGuid,
            applicationGuid: this.currentContextAppGuid,
            safetyThresholdData: page.showStage,
            entity: entityView ? entityView[1] : page.entity,
            limit: page.limit,
            page: page.pageNumber,
            sort: page.sort,
            orderBy: page.orderBy,
            filters: filters
        };
        this.mixpanelService.trackFilterDataBrowsing(mixpanelProperties);
    }
}
